import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function MobileDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mobile Auto Detailing',
    serviceType: 'Mobile Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Ventura County', 'Camarillo', 'Ventura', 'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Newbury Park', 'Westlake Village'],
    description: 'Fully mobile car detailing throughout Ventura County. We bring the detail shop to your home or office with our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  };
  const faqs = [{
    question: 'What is mobile car detailing?',
    answer: "Mobile car detailing is a professional cleaning and restoration service that comes to you. Mike's Pro Detail brings our own water and detailing equipment to your home or office anywhere in Ventura County — no drop-off or waiting room required. We require access to a standard electrical outlet at the service location."
  }, {
    question: 'Do you bring your own water and electricity?',
    answer: 'We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  }, {
    question: 'What areas do you cover for mobile detailing?',
    answer: 'We serve all of Ventura County including Camarillo, Ventura, Thousand Oaks, Simi Valley, Moorpark, Newbury Park, and Westlake Village, plus select surrounding areas.'
  }, {
    question: 'How much does mobile detailing cost?',
    answer: 'Exterior details start at $160, interior at $180, and our popular full detail at $300, with adjustments for vehicle size. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'How long does mobile detailing take?',
    answer: 'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We never rush — quality results take proper time.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Mobile Detailing',
    item: 'https://www.fulldetailpro.com/services/mobile-detailing'
  }];
  return <ServicePageLayout title="Mobile Detailing Ventura County" subtitle="The detail shop that comes to you. Professional mobile car detailing at your home or office anywhere in Ventura County — no drop-off, no waiting." metaDescription="Mobile detailing in Ventura County. Mike's Pro Detail brings interior, exterior & full car detailing to your home or office. 5-star service. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-1009" data-mp="zjku997cw8mz">
      <p data-id="element-1010" data-mp="2g1i9svtkm7pd">
        At Mike's Pro Detail,{' '}
        <strong data-id="element-1011" data-mp="1sfrffq0g8vp">mobile detailing in Ventura County</strong> means professional,
        showroom-quality car care delivered directly to your driveway. There's
        no need to drop your vehicle off, sit in a waiting room, or rearrange
        your day around a detail shop's hours. We bring a fully equipped
        detailing operation — complete with our own water, detailing equipment,
        and premium products — straight to your home or office, wherever you are
        in Ventura County. We require access to a standard electrical outlet at
        the service location.
      </p>

      <h2 data-id="element-1012" data-mp="3jzvpe8n9wfny">Why Choose Mobile Car Detailing?</h2>
      <p data-id="element-1013" data-mp="3nyl01tgxfj3w">
        Mobile car detailing in Ventura County combines the highest quality
        results with unmatched convenience. Instead of automated car washes that
        scratch and swirl your paint, our technicians hand-detail every vehicle
        with meticulous care. And because we come to you, you reclaim hours of
        your day while we transform your car on-site.
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1014" data-mp="16qjdfc55wvk9">
        <li className="flex items-start" data-id="element-1015" data-mp="16tfdp74hfwbv">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1016" data-mp="11t1ducd1bsox" />
          <span data-id="element-1017" data-mp="1fs139m8dgbm5">
            <strong data-id="element-1018" data-mp="1fsiuu5k3a1nq">Total Convenience:</strong> We detail your car at your home,
            office, or apartment — you never have to leave.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1019" data-mp="1bss9ihdc0dql">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1020" data-mp="1ppf4wfpmyvue" />
          <span data-id="element-1021" data-mp="1kr3yyg2gp5hg">
            <strong data-id="element-1022" data-mp="1krm27wnjkjyv">We Bring the Equipment:</strong> We bring our own water and
            detailing equipment. We require access to a standard electrical
            outlet at the service location.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1023" data-mp="1ui88h09dby4w">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1024" data-mp="1uj9ozk95lcu0" />
          <span data-id="element-1025" data-mp="28gy7wmjnu9wf">
            <strong data-id="element-1026" data-mp="28ec0qo0olweq">Premium, Hand-Crafted Results:</strong> Safe wash methods
            and professional-grade products on every vehicle.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1027" data-mp="2n4oq9f166dv3">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1028" data-mp="2s2gjccdjw60v" />
          <span data-id="element-1029" data-mp="2s1oy9vhkxqou">
            <strong data-id="element-1030" data-mp="2s0462ciqmju5">Flexible Scheduling:</strong> Including weekends, to fit
            your busy Ventura County lifestyle.
          </span>
        </li>
      </ul>

      <h2 data-id="element-1031" data-mp="2i2ze1w27nu5f">Our Mobile Detailing Services</h2>
      <p data-id="element-1032" data-mp="24cvz7q5nv2q0">
        Every service we offer is performed on-site as part of our mobile
        detailing operation. Explore each in detail:
      </p>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-1033" data-mp="294e1chjf79ck">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1034" data-mp="1uf81qsgo7h45">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1035" data-mp="1lg4hhl5rovo2">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/full-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1036" data-mp="3nairsaxz6sor">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1037" data-mp="3e8stcl5oethh">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1038" data-mp="5tr6hbldt5o2">
          Headlight Restoration &rarr;
        </Link>
        <Link to="/services/hybrid-ceramic-spray" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1039" data-mp="2lmhpn1mrwcgg">
          Hybrid Ceramic Spray &rarr;
        </Link>
      </div>

      <h2 data-id="element-1040" data-mp="160wa82vzik6q">Serving All of Ventura County</h2>
      <p data-id="element-1041" data-mp="1a4luig5mmfly">
        Our mobile detailing service reaches every community in Ventura County.
        Find your city for local details and pricing:{' '}
        <Link to="/service-areas/camarillo" data-id="element-1042" data-mp="1exotj3t6ah9j">Camarillo</Link>,{' '}
        <Link to="/service-areas/ventura" data-id="element-1043" data-mp="1jtvndy8ao2b4">Ventura</Link>,{' '}
        <Link to="/service-areas/thousand-oaks" data-id="element-1044" data-mp="1oti2kd7onsmk">Thousand Oaks</Link>,{' '}
        <Link to="/service-areas/simi-valley" data-id="element-1045" data-mp="1ovl2boyn104h">Simi Valley</Link>,{' '}
        <Link to="/service-areas/moorpark" data-id="element-1046" data-mp="1ttctggrgki7m">Moorpark</Link>,{' '}
        <Link to="/service-areas/newbury-park" data-id="element-1047" data-mp="1xuyc6iqobqpq">Newbury Park</Link>, and{' '}
        <Link to="/service-areas/westlake-village" data-id="element-1048" data-mp="3vk7sdhgyoxik">Westlake Village</Link>.
      </p>
    </ServicePageLayout>;
}